import React from "react";
import Link from "gatsby-link";
import navigateTo from "../../utils/navigate_to";
import Media from "react-media";
import OnClient from "../OnClient";
import { connect } from "react-redux";
import Logo from "../Logo";
import DocSearch from "./DocSearch/DocSearch";

import UserProfile from "./UserProfile/UserProfile";
import UserDropDown from "./UserDropDown/UserDropDown";
import LogInButton from "./LogInButton/LogInButton";
import BentoMenu from "./BentoMenu/BentoMenu";

import { selectors as docPageSelectors, actions as docPageActions } from "../../reducers/doc_page";

import { navItems } from "./headerConstants";

import "./Header.scss";
import NavItem from "../NavItem/NavItem";

interface HeaderProps {
	isDrawerOpen?: boolean;
	openDrawer?(): any;
	closeDrawer?(): any;
}

class Header extends React.Component<HeaderProps, any> {
	state = {
		isPopoverOpen: false,
		isMenuActive: false,
	};

	handleRequestPopoverClose = () => {
		this.setState({ isPopoverOpen: false });
	};

	handleRequestPopoverOpen = () => {
		this.setState({ isPopoverOpen: true });
	};

	goToPageFromPopover = (url: string) => {
		this.handleRequestPopoverClose();
		navigateTo(url);
	};

	handleMenuActive = () => {
		this.setState({ isMenuActive: !this.state.isMenuActive });
	};

	render() {
		return (
			<Media query={{ maxWidth: 1024 }}>
				{(isMobile) => (
					<OnClient>
						{(hasRendered) => (
							<>
								{hasRendered && (
									<div className="header">
										<div className="header-wrapper">
											<Link className="header-logo" to="/">
												<Logo isHeader={true} />
												<span>DEVELOPER PORTAL</span>
											</Link>

											{!isMobile && (
												<div className="navigation">
													{navItems.map((data, index) => (
														<NavItem
															key={index}
															title={data.title}
															link={data.link}
															activePrefix={data.activePrefix}
															isExternal={data.isExternal}
														/>
													))}
												</div>
											)}

											<div className="general-search-holder">
												<DocSearch
													style={{
														fontSize: 20,
														boxSizing: "border-box",
														backgroundColor: "white",
														justifyContent: "flex-end",
														alignItems: "center",
													}}
													isMobile={isMobile}
												/>
											</div>

											<UserDropDown />
											{!isMobile ? (
												<BentoMenu isMobile={isMobile} />
											) : (
												<button
													className={`hamburger ${this.props.isDrawerOpen ? "active" : ""}`}
													type="button"
													onClick={() => {
														if (this.props.isDrawerOpen) {
															this.props.closeDrawer();
															document.body.style.overflow = "initial";
														} else {
															this.props.openDrawer();
															document.body.style.overflow = "hidden";
														}
													}}
												>
													<span></span>
													<span></span>
													<span></span>
												</button>
											)}

											<UserProfile />
											<LogInButton />
										</div>
									</div>
								)}
							</>
						)}
					</OnClient>
				)}
			</Media>
		);
	}
}

const mapStateToProps = (state) => ({
	isDrawerOpen: docPageSelectors.isDrawerOpen(state),
});

const mapDispatchToProps = {
	openDrawer: docPageActions.openDrawer,
	closeDrawer: docPageActions.closeDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
